import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const CurrencyLiraIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"currency_lira"} ref={ref}/>
});

CurrencyLiraIcon.displayName = "CurrencyLiraIcon";
